export default {
  data() {
    return {
      activeVideoProductId: null,
    }
  },
  methods: {
    videoStateChangeHandler({ id, state }) {
      if (state) {
        this.activeVideoProductId = id
      }
    },
  },
};
